var map = {
	"./PPC MVP/ppc-digital-signage-platform.json": 12688,
	"./PPC MVP/ppc-digital-signage-software.json": 41002,
	"./de/audience-campaigns.json": 29642,
	"./de/blog.json": 5246,
	"./de/broadsign-platform.json": 10957,
	"./de/campaign-planning.json": 46258,
	"./de/components/AquariusMissionInNumbers.json": 11511,
	"./de/components/AquariusSOC2CTABox.json": 25742,
	"./de/components/CaseStudies.json": 5284,
	"./de/components/Footer.json": 30032,
	"./de/components/Form__HubspotCalendly.json": 68720,
	"./de/components/Nav.json": 17996,
	"./de/components/RelatedBlogs.json": 61783,
	"./de/content-network-management.json": 37916,
	"./de/documentation.json": 39364,
	"./de/ebooks.json": 70093,
	"./de/ebooks/guide-to-building-a-successful-digital-signage-network.json": 53641,
	"./de/ebooks/optimize-ooh-sales-through-automation.json": 28361,
	"./de/free-trial.json": 42153,
	"./de/global-programmatic-ssp.json": 47597,
	"./de/global.json": 37801,
	"./de/in-store-retail-platform.json": 893,
	"./de/index.json": 6226,
	"./de/local-signage-messaging.json": 41241,
	"./de/our-story.json": 59192,
	"./de/plans.json": 37490,
	"./de/ppc-digital-signage-platform.json": 26393,
	"./de/ppc-digital-signage-software.json": 5783,
	"./de/privacy-policy.json": 1303,
	"./de/request-a-demo.json": 44007,
	"./de/resources.json": 94787,
	"./de/resources/Webinars.json": 98011,
	"./de/resources/eBooks.json": 4439,
	"./de/security-statement.json": 5024,
	"./de/static-campaigns.json": 70490,
	"./de/subscribe.json": 71330,
	"./de/sustainability-statement.json": 85807,
	"./de/system-on-chip.json": 43472,
	"./de/thank-you.json": 1008,
	"./de/verticals-retail.json": 20627,
	"./de/webinar.json": 87548,
	"./en/auction-packages-automotive.json": 68959,
	"./en/auction-packages-beauty-wellness.json": 23566,
	"./en/auction-packages-consumer-packaged-goods.json": 97958,
	"./en/auction-packages-entertainment-media.json": 48793,
	"./en/auction-packages-financial-services.json": 7776,
	"./en/auction-packages-healthcare-pharma.json": 59289,
	"./en/auction-packages-quick-serve-restaurants.json": 42890,
	"./en/auction-packages-retail.json": 78177,
	"./en/auction-packages-sports-betting.json": 72743,
	"./en/auction-packages-telco-tech.json": 94520,
	"./en/auction-packages-travel-tourism.json": 48182,
	"./en/auction-packages.json": 26771,
	"./en/audience-campaigns.json": 54646,
	"./en/audiences.json": 26649,
	"./en/aws-faq.json": 84426,
	"./en/blog.json": 72602,
	"./en/book-demo.json": 60665,
	"./en/broadsign-platform.json": 96833,
	"./en/campaign-planning.json": 62502,
	"./en/careers.json": 40697,
	"./en/components/AquariusMissionInNumbers.json": 41619,
	"./en/components/AquariusSOC2CTABox.json": 68354,
	"./en/components/BroadsignAdsTestimonials.json": 27614,
	"./en/components/CaseStudies.json": 8272,
	"./en/components/Footer.json": 35508,
	"./en/components/Form__CustomThankYou.json": 26123,
	"./en/components/Form__HubspotCalendly.json": 81404,
	"./en/components/Map.json": 48623,
	"./en/components/Nav.json": 29136,
	"./en/components/Popup__StaticReport.json": 68817,
	"./en/components/RelatedBlogs.json": 68035,
	"./en/contact.json": 32722,
	"./en/content-network-management.json": 34008,
	"./en/documentation.json": 62752,
	"./en/dooh-more.json": 35034,
	"./en/downtime.json": 35151,
	"./en/dsp-account-manager.json": 22649,
	"./en/dsp-how-can-i-buy-digital-out-of-home-media-programmatically.json": 95696,
	"./en/dsp-partners.json": 8139,
	"./en/dsp-thank-you-ebook-dooh-playbook-for-programmatic-buyers.json": 1556,
	"./en/dsp-thank-you-lunch-and-learn.json": 99372,
	"./en/dsp-what-is-programmatic-digital-out-of-home.json": 61464,
	"./en/dsp-why-you-should-add-programmatically-digital-out-of-home-to-your-mobile-campaign.json": 1187,
	"./en/dsp-why-your-next-programmatic-media-campaign-should-include-digital-out-of-home.json": 41756,
	"./en/ebooks.json": 84681,
	"./en/ebooks/create-dooh-campaigns-that-get-results.json": 51571,
	"./en/ebooks/dynamic-and-interactive-content.json": 45750,
	"./en/ebooks/five-common-mistakes-in-digital-signage-content.json": 73202,
	"./en/ebooks/guide-to-building-a-successful-digital-signage-network.json": 28405,
	"./en/ebooks/how-to-add-digital-to-your-static-ooh-network.json": 95164,
	"./en/ebooks/how-to-modernize-your-traditional-ooh-business.json": 83344,
	"./en/ebooks/in-store-activation.json": 73248,
	"./en/ebooks/increase-revenue-with-contextual-in-store-media.json": 73335,
	"./en/ebooks/media-buyers-guide-to-programmatic-digital-out-of-home.json": 63325,
	"./en/ebooks/optimize-ooh-sales-through-automation.json": 60261,
	"./en/ebooks/rise-of-retail-media.json": 97700,
	"./en/ebooks/seven-habits-of-highly-effective-dooh-media-owners.json": 63256,
	"./en/ebooks/six-steps-for-integrating-dooh-in-your-omnichannel-strategy.json": 62245,
	"./en/ebooks/state-of-static-ooh-report.json": 11708,
	"./en/ebooks/unlock-more-value-from-your-ev-charging-stations.json": 14221,
	"./en/events-2022-05-broadsign-fete.json": 67649,
	"./en/events-alooh-mexico-2024.json": 56960,
	"./en/events-broadsign-connect-summit-2024.json": 59435,
	"./en/events-broadsign-connect-summit-2025.json": 58024,
	"./en/events-broadsign-summit-2019.json": 35104,
	"./en/events-broadsign-summit-2020.json": 11344,
	"./en/events-csp-forum-2025.json": 10608,
	"./en/events-ise-customer-summit-2023.json": 33866,
	"./en/events-ooh-social-mexico-2025.json": 19416,
	"./en/events-ooh-social-milan-2024.json": 3731,
	"./en/events-woo-south-africa.json": 4590,
	"./en/events.json": 55555,
	"./en/free-trial.json": 75981,
	"./en/gate.json": 24685,
	"./en/global-programmatic-ssp.json": 96033,
	"./en/global.json": 13469,
	"./en/in-store-retail-platform.json": 55209,
	"./en/index.json": 27350,
	"./en/inventory-marketplace-chicago.json": 81729,
	"./en/inventory-marketplace-los-angeles.json": 23791,
	"./en/inventory-marketplace-new-york-city.json": 39839,
	"./en/inventory-marketplace-philadelphia.json": 54052,
	"./en/inventory-marketplace-toronto.json": 44632,
	"./en/inventory-marketplace-vancouver.json": 1038,
	"./en/inventory-marketplace.json": 17240,
	"./en/launch-pdooh-campaign.json": 48019,
	"./en/local-signage-messaging.json": 36597,
	"./en/logos.json": 52826,
	"./en/measurement-attribution.json": 7114,
	"./en/ooh-media-software.json": 68065,
	"./en/our-story.json": 81564,
	"./en/outmoove.json": 83554,
	"./en/partners-microsoft.json": 49256,
	"./en/partners-zitcha.json": 43599,
	"./en/plans.json": 52542,
	"./en/ppc-digital-signage-platform.json": 59661,
	"./en/ppc-digital-signage-software.json": 81275,
	"./en/privacy-policy.json": 27003,
	"./en/product-summit-2022.json": 68400,
	"./en/programmatic-platform-policies.json": 64789,
	"./en/programmatic-u.json": 55838,
	"./en/request-a-demo.json": 6011,
	"./en/resources.json": 93263,
	"./en/resources/Webinars.json": 68223,
	"./en/resources/eBooks.json": 33755,
	"./en/resubscribe.json": 33337,
	"./en/security-statement.json": 25932,
	"./en/seo-digital-signage-software-canada.json": 10192,
	"./en/sitemap.json": 77245,
	"./en/sla.json": 37856,
	"./en/static-campaigns.json": 37630,
	"./en/subscribe-community-digest.json": 7069,
	"./en/subscribe-product-news.json": 24944,
	"./en/sustainability-statement.json": 26251,
	"./en/system-on-chip.json": 71452,
	"./en/terms-conditions.json": 96470,
	"./en/thank-you.json": 75188,
	"./en/training.json": 3436,
	"./en/verticals-airports.json": 66924,
	"./en/verticals-banking.json": 20470,
	"./en/verticals-casino.json": 88831,
	"./en/verticals-cinema.json": 87483,
	"./en/verticals-ev.json": 53611,
	"./en/verticals-gas-stations.json": 83046,
	"./en/verticals-healthcare.json": 75183,
	"./en/verticals-hotels.json": 71819,
	"./en/verticals-internal-communications.json": 88493,
	"./en/verticals-outdoor.json": 66620,
	"./en/verticals-retail.json": 92231,
	"./en/verticals-shopping-malls.json": 24674,
	"./en/verticals-smart-cities.json": 22915,
	"./en/verticals-transit.json": 30207,
	"./en/webinar.json": 48032,
	"./en/webinars-2024-09-attribution-for-dooh-advertising.json": 69172,
	"./en/webinars-2024-10-using-brand-lift-studies-to-measure-dooh-impact.json": 81424,
	"./en/webinars-2025-04-new-on-the-broadsign-platform.json": 48785,
	"./en/webinars-audience-campaign-sales-strategy.json": 95088,
	"./en/webinars-broadsign-platform-training.json": 98108,
	"./en/webinars-diversify-profit-grow.json": 65566,
	"./en/webinars-evolution-of-the-broadsign-platform-2023.json": 62597,
	"./en/webinars-new-on-the-broadsign-platform.json": 29690,
	"./en/webinars-pdooh-for-buyers.json": 81623,
	"./en/webinars-platform-training-audience-campaigns.json": 23327,
	"./en/webinars-platform-training-guaranteed-campaigns.json": 60927,
	"./en/webinars-spotlight-on-static-campaigns.json": 29669,
	"./en/who-we-are.json": 76506,
	"./es/audience-campaigns.json": 17271,
	"./es/blog.json": 69699,
	"./es/broadsign-platform.json": 8544,
	"./es/campaign-planning.json": 23149,
	"./es/components/AquariusMissionInNumbers.json": 4856,
	"./es/components/AquariusSOC2CTABox.json": 54413,
	"./es/components/CaseStudies.json": 84841,
	"./es/components/Footer.json": 99059,
	"./es/components/Form__CustomThankYou.json": 32216,
	"./es/components/Form__HubspotCalendly.json": 66485,
	"./es/components/Nav.json": 44513,
	"./es/components/RelatedBlogs.json": 65152,
	"./es/contact.json": 38753,
	"./es/content-network-management.json": 79797,
	"./es/documentation.json": 11039,
	"./es/ebooks.json": 78868,
	"./es/ebooks/guide-to-building-a-successful-digital-signage-network.json": 19146,
	"./es/ebooks/how-to-modernize-your-traditional-ooh-business.json": 99755,
	"./es/ebooks/state-of-static-ooh-report.json": 68483,
	"./es/events-alooh-mexico-2024.json": 84493,
	"./es/free-trial.json": 53656,
	"./es/global-programmatic-ssp.json": 52698,
	"./es/global.json": 61312,
	"./es/in-store-retail-platform.json": 91208,
	"./es/index.json": 5589,
	"./es/local-signage-messaging.json": 64042,
	"./es/our-story.json": 84095,
	"./es/plans.json": 46953,
	"./es/ppc-digital-signage-software.json": 87218,
	"./es/privacy-policy.json": 69014,
	"./es/request-a-demo.json": 27982,
	"./es/resources.json": 80748,
	"./es/resources/Webinars.json": 96230,
	"./es/resources/eBooks.json": 80922,
	"./es/security-statement.json": 5233,
	"./es/static-campaigns.json": 20775,
	"./es/sustainability-statement.json": 30406,
	"./es/system-on-chip.json": 84425,
	"./es/thank-you.json": 52723,
	"./es/verticals-retail.json": 73830,
	"./es/webinar.json": 2115,
	"./es/webinars-platform-training-es-inventario-usuarios.json": 87826,
	"./es/webinars-sacale-mas-provecho-al-cms-de-broadsign.json": 74537,
	"./es/who-we-are.json": 99995,
	"./fr/auction-packages-automotive.json": 39088,
	"./fr/auction-packages-beauty-wellness.json": 8047,
	"./fr/auction-packages-consumer-packaged-goods.json": 74551,
	"./fr/auction-packages-entertainment-media.json": 44832,
	"./fr/auction-packages-financial-services.json": 93663,
	"./fr/auction-packages-healthcare-pharma.json": 83280,
	"./fr/auction-packages-quick-serve-restaurants.json": 63479,
	"./fr/auction-packages-retail.json": 35110,
	"./fr/auction-packages-sports-betting.json": 28856,
	"./fr/auction-packages-telco-tech.json": 61171,
	"./fr/auction-packages-travel-tourism.json": 16833,
	"./fr/auction-packages.json": 83654,
	"./fr/audience-campaigns.json": 94479,
	"./fr/audiences.json": 59810,
	"./fr/aws-faq.json": 7457,
	"./fr/blog.json": 46235,
	"./fr/book-demo.json": 78142,
	"./fr/broadsign-platform.json": 46728,
	"./fr/campaign-planning.json": 28805,
	"./fr/careers.json": 80094,
	"./fr/components/AquariusMissionInNumbers.json": 20224,
	"./fr/components/AquariusSOC2CTABox.json": 2869,
	"./fr/components/BroadsignAdsTestimonials.json": 55937,
	"./fr/components/CaseStudies.json": 18289,
	"./fr/components/Footer.json": 36027,
	"./fr/components/Form__HubspotCalendly.json": 99661,
	"./fr/components/Map.json": 25154,
	"./fr/components/Nav.json": 85353,
	"./fr/components/RelatedBlogs.json": 56920,
	"./fr/contact.json": 45193,
	"./fr/content-network-management.json": 45530,
	"./fr/documentation.json": 97799,
	"./fr/downtime.json": 68082,
	"./fr/dsp-partners.json": 51822,
	"./fr/ebooks.json": 88572,
	"./fr/ebooks/five-common-mistakes-in-digital-signage-content.json": 31783,
	"./fr/ebooks/guide-to-building-a-successful-digital-signage-network.json": 12434,
	"./fr/ebooks/six-steps-for-integrating-dooh-in-your-omnichannel-strategy.json": 95780,
	"./fr/free-trial.json": 9120,
	"./fr/global-programmatic-ssp.json": 48146,
	"./fr/global.json": 10664,
	"./fr/in-store-retail-platform.json": 75408,
	"./fr/index.json": 9389,
	"./fr/inventory-marketplace.json": 30627,
	"./fr/launch-pdooh-campaign.json": 96188,
	"./fr/local-signage-messaging.json": 25554,
	"./fr/measurement-attribution.json": 8781,
	"./fr/ooh-media-software.json": 82776,
	"./fr/our-story.json": 86279,
	"./fr/outmoove.json": 3247,
	"./fr/plans.json": 83633,
	"./fr/privacy-policy.json": 86494,
	"./fr/programmatic-platform-policies.json": 4744,
	"./fr/request-a-demo.json": 19782,
	"./fr/resources.json": 21668,
	"./fr/resources/Webinars.json": 81918,
	"./fr/resources/eBooks.json": 52770,
	"./fr/security-statement.json": 55513,
	"./fr/static-campaigns.json": 99983,
	"./fr/sustainability-statement.json": 63982,
	"./fr/system-on-chip.json": 16321,
	"./fr/thank-you.json": 98811,
	"./fr/training.json": 80465,
	"./fr/verticals-airports.json": 95197,
	"./fr/verticals-banking.json": 24741,
	"./fr/verticals-casino.json": 84446,
	"./fr/verticals-cinema.json": 90038,
	"./fr/verticals-gas-stations.json": 47192,
	"./fr/verticals-healthcare.json": 37282,
	"./fr/verticals-hotels.json": 73166,
	"./fr/verticals-internal-communications.json": 33250,
	"./fr/verticals-outdoor.json": 14215,
	"./fr/verticals-retail.json": 26894,
	"./fr/verticals-shopping-malls.json": 64907,
	"./fr/verticals-smart-cities.json": 2086,
	"./fr/verticals-transit.json": 36860,
	"./fr/webinar.json": 16651,
	"./fr/who-we-are.json": 39923,
	"./global/Forms.json": 42649,
	"./global/Leaders.json": 51748,
	"./id/components/Nav.json": 69166,
	"./id/global.json": 64715,
	"./id/ppc-digital-signage-software.json": 14889,
	"./ja/blog.json": 83660,
	"./ja/broadsign-platform.json": 7395,
	"./ja/campaign-planning.json": 21244,
	"./ja/components/AquariusMissionInNumbers.json": 67765,
	"./ja/components/AquariusSOC2CTABox.json": 17012,
	"./ja/components/CaseStudies.json": 49946,
	"./ja/components/Footer.json": 4322,
	"./ja/components/Form.json": 82619,
	"./ja/components/Nav.json": 46050,
	"./ja/content-network-management.json": 80022,
	"./ja/documentation.json": 68798,
	"./ja/free-trial.json": 29095,
	"./ja/global-programmatic-ssp.json": 45947,
	"./ja/global.json": 52815,
	"./ja/index.json": 8052,
	"./ja/local-signage-messaging.json": 91115,
	"./ja/plans.json": 10440,
	"./ja/ppc-digital-signage-platform.json": 66327,
	"./ja/request-a-demo.json": 75965,
	"./ja/static-campaigns.json": 54708,
	"./ja/system-on-chip.json": 19670,
	"./ja/who-we-are.json": 36720,
	"./nl/components/Nav.json": 10695,
	"./nl/global.json": 29798,
	"./nl/ppc-digital-signage-platform.json": 6782,
	"./pt/blog.json": 26487,
	"./pt/components/Footer.json": 82319,
	"./pt/components/Nav.json": 16861,
	"./pt/components/RelatedBlogs.json": 96676,
	"./pt/global.json": 1932,
	"./pt/pt.json": 1299,
	"./zh/broadsign-platform.json": 73702,
	"./zh/campaign-planning.json": 2167,
	"./zh/components/AquariusMissionInNumbers.json": 78350,
	"./zh/components/AquariusSOC2CTABox.json": 16683,
	"./zh/components/CaseStudies.json": 26431,
	"./zh/components/Footer.json": 4837,
	"./zh/components/Nav.json": 1119,
	"./zh/contact.json": 52103,
	"./zh/content-network-management.json": 76255,
	"./zh/documentation.json": 55769,
	"./zh/ebooks/guide-to-building-a-successful-digital-signage-network.json": 62916,
	"./zh/ebooks/optimize-ooh-sales-through-automation.json": 47338,
	"./zh/free-trial.json": 1334,
	"./zh/global-programmatic-ssp.json": 10144,
	"./zh/global.json": 84286,
	"./zh/index.json": 19199,
	"./zh/local-signage-messaging.json": 82220,
	"./zh/plans.json": 90519,
	"./zh/request-a-demo.json": 92196,
	"./zh/resources/Webinars.json": 35808,
	"./zh/resources/eBooks.json": 95372,
	"./zh/static-campaigns.json": 90209,
	"./zh/system-on-chip.json": 44263,
	"./zh/who-we-are.json": 56821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49401;